import { CollaborationApiResponse } from './types';

const API_BASE_URL = 'https://vlsiapi.bssoftcrm.com';

// GET API - Fetch collaboration page content
export const fetchCollaborationContent =
  async (): Promise<CollaborationApiResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/Collaboration`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: CollaborationApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching collaboration content:', error);
      throw error;
    }
  };
